import { Icon } from '@chakra-ui/icons';

export const TransactionMobileInfoIcon = ({ color = 'backgroundTertiary' }: { color?: string }) => (
	<Icon
		width="16px"
		height="16px"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M7.99967 14.6663C11.6816 14.6663 14.6663 11.6816 14.6663 7.99968C14.6663 4.31778 11.6816 1.33301 7.99967 1.33301C4.31778 1.33301 1.33301 4.31778 1.33301 7.99968C1.33301 11.6816 4.31778 14.6663 7.99967 14.6663Z"
			stroke={color}
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8 10.6667V8"
			stroke={color}
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M8 5.33325H8.01"
			stroke={color}
			strokeWidth="1.6"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Icon>
);
